import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { getScenarioById } from "@/data/scenario-registry";
import { GameplayScreen } from "@/components/GameplayScreen";

export default function LifePlayPage() {
  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();
  const scenarioId = useMemo(() => params.id ?? "", [params.id]);
  const [notFound, setNotFound] = useState(false);
  const script = getScenarioById(scenarioId);

  useEffect(() => {
    if (!script) {
      setNotFound(true);
    } else {
      setNotFound(false);
    }
  }, [script]);

  if (notFound) {
    return (
      <div className="container mx-auto px-4 py-12">
        <div className="mx-auto max-w-md rounded-xl border bg-card p-6 text-center">
          <h2 className="text-xl font-bold mb-2">
            {t("lifePlay.notFoundTitle", { defaultValue: "未找到剧本" })}
          </h2>
          <p className="text-muted-foreground mb-4">
            {t("lifePlay.notFoundDesc", { defaultValue: "请返回并选择其他场景。" })}
          </p>
          <button
            className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-primary-foreground"
            onClick={() => navigate(-1)}
          >
            {t("common.back", { defaultValue: "返回" })}
          </button>
        </div>
      </div>
    );
  }

  if (!script) return null;
  // GameplayScreen handles header offset internally; render directly with provided script
  return <GameplayScreen script={script} />;
}
